import { createAsyncThunk } from "@reduxjs/toolkit";
import { PutVouchersResponsibleUserParams } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const putVouchersResponsibleUser = createAsyncThunk<
  void,
  PutVouchersResponsibleUserParams
>("vouchers/putVouchersResponsibleUser", async (body, { rejectWithValue }) => {
  try {
    await VouchersAPI.putVouchersResponsibleUser(body);
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error(
        "Error while updating responsible user",
        error.response?.data
      );
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while updating responsible user", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
